module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAiBAMAAADbvlYFAAAAAXNSR0IB2cksfwAAAC1QTFRFAAAAGYztGI7sII/vGYztGY3tGo3tGY7tGY3tGY3uG4/vGY3tGoztGIvrGo3tIP/UYQAAAA90Uk5TAG9fEM//n5DQrzDvoEDwzr5ogAAAAIhJREFUeJzV0LsNgDAMBFAjOpQhGIGCFRjhAImGXZiCLhMwABJlRmEPlA8F9i1AulhP1vlEzKtaO5N6GMm0B1ZCgYlRgFHMlG6Udr+ju2cUJ9uKxZOtKPgbAAV/AyBjlRUZq6xIWJ8VEtZnufi/TAMRwzTgylCVFQh9sek1sF7lYFSam9CIFX0A91FS//EGcWMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_support.png
// module id = TgRQ
// module chunks = 1